export default "__VITE_ASSET__7flaAxMG__"